import { render, staticRenderFns } from "./RealestateIcon.vue?vue&type=template&id=3522495a&"
import script from "./RealestateIcon.vue?vue&type=script&lang=js&"
export * from "./RealestateIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports